import React from 'react';

export const VerticalLine = () => (
    <svg
        width="6"
        height="93"
        viewBox="0 0 6 93"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="-mt-7 -mb-7 hidden lg:block"
    >
        <path d="M3 0V93" stroke="url(#paint0_linear_2413_20433)" />
        <path d="M3 22V28" stroke="#FF622B" />
        <path d="M6 25L0 25" stroke="#FF622B" />
        <path d="M3 66V72" stroke="#FF622B" />
        <path d="M6 69L0 69" stroke="#FF622B" />
        <defs>
            <linearGradient
                id="paint0_linear_2413_20433"
                x1="1.50012"
                y1="-8.00011"
                x2="1.50012"
                y2="93"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#EAEAEA" stopOpacity="0" />
                <stop
                    offset="0.532358"
                    stopColor="#B4B4B4"
                    stopOpacity="0.467642"
                />
                <stop offset="1" stopColor="#848484" stopOpacity="0" />
            </linearGradient>
        </defs>
    </svg>
);
